import each from 'lodash-es/each'
import dayjs from 'dayjs'
import * as common from '@c4-links/vuejs-utilities/src/utils/dates/common'

const filtersFields = [
  {
    key: 'country',
    label: 'Country',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_COUNTRY || 445,
    lookerField: 'filters_g40.country_desc',
    group: 'general',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Country Name'
  },
  {
    key: 'chain_type_desc',
    label: 'Chain type',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_CHAINTYPEDESC || 443,
    lookerField: 'filters_g40.chain_type_desc',
    group: 'general',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Chain Type'
  },
  {
    key: 'departement',
    label: 'Departement',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_DEPARTEMENT || 446,
    lookerField: 'filters_g40.department_desc',
    group: 'hierarchy',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Department Desc'
  },
  {
    key: 'class_desc_key',
    label: 'Class desc - key',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_CLASSDESC_KEY || 452,
    lookerField: 'filters_g40.class_desc_key',
    group: 'hierarchy',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Class Desc - Key'
  },
  {
    key: 'class_desc',
    label: 'Class',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_CLASSDESC || 444,
    lookerField: 'filters_g40.class_desc',
    group: 'hierarchy',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Class'
  },
  {
    key: 'class_key',
    label: 'Class key',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_CLASS_KEY || 453,
    lookerField: 'filters_g40.class_key',
    group: 'hierarchy',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Class Key'
  },
  {
    key: 'grp_class_desc_key',
    label: 'Grp Class desc - key',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_GRPCLASSDESC_KEY || 454,
    lookerField: 'filters_g40.grp_class_desc_key',
    group: 'hierarchy',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Grp Class Desc - Key'
  },
  {
    key: 'grp_class_desc',
    label: 'Grp Class',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_GRPCLASSDESC || 447,
    lookerField: 'filters_g40.grp_class_desc',
    group: 'hierarchy',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Grp Class'
  },
  {
    key: 'grp_class_key',
    label: 'Grp Class key',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_GRPCLASS_KEY || 455,
    lookerField: 'filters_g40.grp_class_key',
    group: 'hierarchy',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Grp Class Key'
  },
  {
    key: 'brand',
    label: 'Brand',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_BRAND || 442,
    lookerField: 'filters_g40.brand_desc',
    group: 'information',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Brand Desc'
  },
  {
    key: 'item_desc_barcode',
    label: 'Product desc - barcode',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_PRODUCTDESC || 451,
    lookerField: 'filters_g40.item_desc_barcode',
    group: 'information',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Product Desc - Barcode'
  },
  {
    key: 'barcode',
    label: 'Barcode',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_BARCODE || 441,
    lookerField: 'filters_g40.barcode',
    group: 'information',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Barcode'
  },
  {
    key: 'item',
    label: 'Product desc',
    type: 'checkbox',
    default: [],
    look: process.env.VUE_APP_LOOKID_FILTER_G40_ITEM || 448,
    lookerField: 'filters_g40.item_desc',
    group: 'information',
    searchable: true,
    bulkSelectable: true,
    lookerFilter: 'Product Desc'
  },
  {
    key: 'class',
    label: 'Class',
    type: 'radio',
    default: 'International',
    group: 'other',
    lookerField: 'parameters_g40.class_parameter',
    lookerFilter: 'Class Parameter',
  },
  {
    key: 'vat',
    label: 'VAT',
    type: 'radio',
    default: 'WTVAT',
    group: 'other',
    lookerField: 'parameters_g40.VAT_parameter',
    lookerFilter: 'With / Without VAT'
  },
  {
    key: 'currency',
    label: 'Currency',
    type: 'radio',
    default: 'EURO',
    group: 'other',
    lookerField: 'parameters_g40.currency_parameter',
    lookerFilter: 'Currency'
  },
  {
    key: 'dateRangePreset',
    label: 'Date Range Preset',
    default: ''
  },
  {
    key: 'dateRange',
    label: 'Date Range',
    default: '',
    lookerField: 'filters_g40.current_date_range',
    lookerFilter: 'Transaction Date Range',
    lookerFieldAlt: ['period_over_period_g40.current_date_range']
  },
  {
    key: 'dateTimeframe',
    label: 'Date Timeframe',
    default: 'month',
    lookerField: 'parameters_g40.timeframe_parameter',
    lookerFilter: 'Timeframe Parameter'
  }
]

const defaultSearchInput = {}
const defaultFiltersOptions = {}
const defaultFiltersLoading = {}
const defaultFilters = {}

each(filtersFields, f => {
  defaultSearchInput[f.key] = ''
  defaultFiltersOptions[f.key] = []
  defaultFiltersLoading[f.key] = false
  defaultFilters[f.key] = f.default
  if (f.key === 'dateRange') {
    const now = dayjs()
    const isAfterMiddleMonth = common.isAfterMiddleMonth(now)
    const endOfPrevMonth = common.endOfPreviousMonth(now)
    const endOfPrev2Month = common.endOfPreviousMonth(endOfPrevMonth)
    const prev = isAfterMiddleMonth ? endOfPrevMonth : endOfPrev2Month
    const start = prev.startOf('month')
    const end = prev.endOf('month')
    const range = start.format('YYYY/MM/DD') + ' to ' + end.format('YYYY/MM/DD')
    defaultFilters[f.key] = range
  }
})

defaultFiltersOptions.currency = [
  { key: 'EURO', label: 'Euro' },
  { key: 'FER', label: 'Fixed Euro' },
  { key: 'LOCAL', label: 'Local' }
]

defaultFiltersOptions.class = [
  { key: 'International', label: 'International' },
  { key: 'Local', label: 'Local' }
]
defaultFiltersOptions.vat = [
  { key: 'WTVAT', label: 'With' },
  { key: 'WOVAT', label: 'Without' }
]

export default () => {
  return {
    filtersFields,
    defaultSearchInput,
    defaultFiltersOptions,
    defaultFiltersLoading,
    defaultFilters
  }
}
